import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import RaisedButton from 'material-ui/RaisedButton'
import * as Fetch from '../util/Fetch'
import * as AuthActions from '../actions/AuthActions'
import * as SettingContractAction from '../actions/SettingContactAction'

class Contract extends Component {
	constructor(props) {
		super(props)
		this.state = {
			consent: false,
		}
	}
	componentWillMount() {

		const { dispatch } = this.props
		dispatch(SettingContractAction.getAllContractAction())
	}

	handlerClick(res) {
		const { dispatch } = this.props
		this.setState({ consent: res })
		if (res) {
			localStorage.setItem('isAcceptTermOfUser', 'true')
			dispatch(AuthActions.acceptTermOfUse())
			return;
		}
		return window.location.pathname = '/login'
	}


	render() {
		const { SettingContractTerm } = this.props
		if (this.state.consent) {
			// global.showDialogFirstLogin = true
			return <Redirect to={{ pathname: '/home' }} />
		}
		return (
			<div className="content">
				<h1 className="content__title">Stella 利用規約</h1>
				<p className="content__title title_color">
					【重要】 お仕事開始前に、下記の利用規約をお読みください。
				</p>
				<div className="primary">
					<div className="primary__inner" dangerouslySetInnerHTML={{ __html: SettingContractTerm.data }}>
					</div>
				</div>
				<div>
					<RaisedButton
						label="同意しない"
						onClick={() => this.handlerClick(false)}
						style={styleRaisedButton}
					/>
					<RaisedButton
						label="同意する"
						primary={true}
						onClick={() => this.handlerClick(true)}
						style={styleRaisedButton}
					/>
				</div>
			</div>

		)
	}
}

const styleRaisedButton = {
	margin: 10,
}

const mapStateToProps = (state) => {
	return {
		SettingContractTerm: state.SettingContractTerm
	}
}

export default connect(mapStateToProps)(Contract)
